import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
export function getChildPagesForSlug(slug, pages) {
  return pages.filter(function (_ref) {
    var currentSlug = _ref.slug;
    return currentSlug.startsWith(slug) && currentSlug !== slug;
  });
}
export function groupPagesBySlug(pages) {
  var groupedPages = [];
  pages.forEach(function (page) {
    var slug = page.slug;
    var childPages = getChildPagesForSlug(slug, pages);
    if (!_isEmpty(childPages)) {
      groupedPages = [].concat(_toConsumableArray(groupedPages), [_objectSpread(_objectSpread({}, page), {}, {
        childPages: childPages
      })]);
    }
  });
  return groupedPages;
}